import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSkills, saveSkill, getExerciseMapping
        } from '../../actions';
import './workouts.css';

class Skills extends Component {
  initState = {
    _id: '',
    type:'',
    level:'',
    workout: [{
      rounds: '',
      timeOn: '',
      timeOff: '',
      exercises: []
    }],
    checked: []
  }

  state = {
    skills: [],
    search: '',
    ...this.initState
  }

  componentWillMount = () => {
    this.props.getSkills();

    if(!this.props.exerciseMapping) {
      this.props.getExerciseMapping();
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if((nextProps.workoutSaved && nextProps.workoutSaved.success) || 
        (nextProps.deleteWorkout && nextProps.deleteWorkout.success) ||
        nextProps.saveToProd 
      ) {
      return this.props.getSkills();
    }

    if(nextProps.skills) {
      this.setState({
        skills: nextProps.skills
      })
    }
  }


  handleChange = (evt, index, exerciseIndex ) => {
    const name = evt.target.name;
    let value = evt.target.value;

    if(index >= 0 && Object.keys(this.state.workout[index]).indexOf(name) !== -1 ){
      let workout = this.state.workout
      if(name === 'exercises') {
        let exercises = workout[index].exercises
        exercises[exerciseIndex] = value
        workout[index] = { ...workout[index], exercises }
      } else {
        workout[index] = {...workout[index], [name]: value}
      }
      this.setState({
        ...this.state,
        workout: workout
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value
      });
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({
      ...this.initState
    });

    this.props.saveSkill(this.state);
  }

  
  editWorkout = (skill) => {
    this.setState({
      _id: skill._id || '',
      type:skill.type || '',
      level:skill.level || '',
      workout: skill.workout || [{
        rounds: '',
        timeOn: '',
        timeOff: '',
        exercises: []
      }]
    })
  }

  
  checkboxClick = (skill) => {
      let index = this.state.checked.indexOf(skill._id);
      if(index !== -1) {
        let checked = this.state.checked.filter(checked => checked !== skill._id)
        
        this.setState({
          checked
        })
      } else {
        this.setState({
          checked: [...this.state.checked, skill._id]
        })
      }
  }

  addRound = (e) => {
    e.preventDefault()
    if (this.state.workout) {
      this.setState({
        workout: [...this.state.workout, {
          rounds: '',
          timeOn: '',
          timeOff: '',
          exercises: []
        }]
      })
    } 
  }

  addExercise = (e, index) => {
    let workout =this.state.workout
    e.preventDefault()
    if (workout && workout[index]) {
      workout[index].exercises.push('')
      this.setState({
        workout
      })
    } 
  }

  removeInner = (e, index, type, exerciseIndex) => {
    e.preventDefault();
    let workout;
    switch (type) {
      case 'round':
        workout = this.state.workout.filter((round, i) => i !== index);
        this.setState({
          workout
        })
        break;
      case 'exercise':
        let exercises = this.state.workout[index].exercises.filter((round, i) => i !== exerciseIndex);
        workout = this.state.workout
        workout[index].exercises = exercises
        this.setState({
          workout
        })
        break;
      default:
        break;
    }
  }
  // addToProduction = () => {
  //   let workouts = [];
  //   this.state.checkedWorkout.forEach(id => {
  //     workouts.push(this.state.workouts.find(workout => workout._id === id));
  //   })

  //   this.setState({
  //     ...this.initState
  //   })
  //   if(workouts.length > 0) {
  //     this.props.saveWorkoutsToProd(workouts);
  //   }
  // }
  renderWorkouts = () => (
    this.state.skills ? 
      this.renderWorkoutsMap(this.state.skills)
    : null
  )

  renderPresentName = (exercises) => (
    exercises ? 
    exercises.sort((a,b) => (a.present_name > b.present_name) ? 1 : ((b.present_name > a.present_name) ? -1 : 0))
    .map((exercise, j) => { 
      return <option key={j} value={exercise.present_name}> { exercise.present_name }</option> 
    }):
    null
  )
  renderRounds = () => (
    this.state.workout ? this.state.workout.map((round, i) => {
      return <div key={i} className="round">
        <div>
          <button className="close deleteInner" onClick={(e) => this.removeInner(e, i, 'round')}>&times;</button>
        </div>
        <input className="input input-motivation"  name="rounds" type="number" 
                value={this.state.workout[i].rounds} onChange={(e) => this.handleChange(e, i)} placeholder="Rounds"/>
        <input className="input input-motivation"  name="timeOn" type="number" 
                value={this.state.workout[i].timeOn} onChange={(e) => this.handleChange(e, i)} placeholder="Time On"/>
        <input className="input input-motivation"  name="timeOff" type="number" 
                value={this.state.workout[i].timeOff} onChange={(e) => this.handleChange(e, i)} placeholder="Time Off"/>
          {
            round.exercises && round.exercises.length !== 0 ? round.exercises.map((exercise, j) => {
              return <div key={j} style={{display: 'inline'}}> 
                <div>
                  <button className="close deleteExercise deleteInner" onClick={(e) => this.removeInner(e, i, 'exercise', j)}>&times;</button>
                </div>
                <select className="input input-motivation select-exercise-skills" name="exercises" type="text" placeholder="exercise" 
                  value={this.state.workout[i].exercises[j] || ''} onChange={(e) => this.handleChange(e, i,j)}>
                  <option>Select</option>
                  {this.renderPresentName(this.props.exerciseMapping)}
                </select>
              </div>
            }) : <select className="input input-motivation" name="exercises" type="text" placeholder="exercise" 
            value={this.state.workout[i].exercises[0] || ''} onChange={(e) => this.handleChange(e, i,0)}>
                <option>Select</option>
                {this.renderPresentName(this.props.exerciseMapping)}
              </select>
          }
          <button onClick={(e) => this.addExercise(e, i)} className="savebtn"> 
                    Add Exercise 
            </button>
      </div>
    }) : null
  )

  renderWorkoutsMap = (skills) => (
    skills.sort((a,b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0))
    .map((skill, i) => {
      return <div key={i} className="inline-row-workout"> 
        <div className="column column-checkbox" ><input className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(skill._id) === -1 ? false : true} 
          onChange={() => this.checkboxClick(skill)}/></div>
        <div className="column column-name" onClick={() => { this.editWorkout(skill)}}> {skill.type} </div>
        <div className="column"> {skill.level} </div>
      </div>
    }) 
  )

  render() {
    console.log(this.state.skills);
    return (
      <div className="">
        <div className="inline">
          <div className="workouts-div">
                <h2 className="workout-title">SKILLS</h2>
                <div className="inline">
                  <input className="select-motivation search-input search-workout" type="text" placeholder="Search"  name="search" value={this.state.search} onChange={this.handleChange}/>
                  {
                    process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                      <button onClick={this.addToProduction} className="addButton final-btn">Add To Production</button>
                    : null
                  }
                </div>
                <div className="specific-feedbacks-head inline-row-workout">
                  <div className="column column-head column-checkbox"></div>
                  <div className="column column-head column-name">Type</div>
                  <div className="column column-head">Level</div>
                </div>
                <div className="specific-feedbacks">
                  {this.renderWorkouts()}
                </div> 
                {
                    this.props.workoutSaved && !this.props.workoutSaved.success && this.props.workoutSaved.error ? 
                    <p className="error-message">Error Saving workout - { this.props.workoutSaved.error.message }</p> : 
                    null
                  }
              </div>
          <form onSubmit={this.submitForm} className="add-form" style={{marginTop: 0}}> 
            <div style={{display: 'grid'}}>
              <h2 className="headline">Add skill</h2>
              <input 
                    name="type"
                    type="text"
                    className="input input-motivation"
                    placeholder="Type"
                    value={this.state.type}
                    onChange={this.handleChange}
                />
                <input 
                    name="level"
                    type="number"
                    className="input input-motivation"
                    placeholder="Level"
                    value={this.state.level}
                    onChange={this.handleChange}
                />
                <div className="rounds">
                  {this.renderRounds()}
                  <button onClick={this.addRound} className="savebtn" style={{backgroundColor: 'hotpink'}}> 
                    Add Round 
                    </button>
                </div>
              </div>
            <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    skills: state.workout.skills,
    exerciseMapping: state.workout.exerciseMapping,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getSkills, saveSkill, getExerciseMapping },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Skills);